import { useState } from 'react'
import { apiService } from '@/services/api'
import { Button, OneOf } from '@/design-system/primitives'
import '@/design-system/first-week.css'
import { BRANCH_OPTIONS, BRANCH_QUESTION } from './firstWeekCopy'

type Branch = (typeof BRANCH_OPTIONS)[number]['value']

/*
  Asked once, in place, when onboarding never recorded who runs the site.
  The answer is written where onboarding would have put it, so nothing else
  in the product needs a second source.
*/
export function FirstWeekBranchAsk({ onAnswered }: { onAnswered: () => void }) {
  const [value, setValue] = useState<Branch | ''>('')
  const [saving, setSaving] = useState(false)
  const [failed, setFailed] = useState(false)

  async function save() {
    if (!value) return
    setSaving(true)
    setFailed(false)
    try {
      await apiService.answerFirstWeekBranch(value)
      onAnswered()
    } catch {
      setFailed(true)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="ds-fw__ask">
      {/* Three short answers side by side: stacked, they stood a column of
          cards beside an empty page. The control goes back to one column on
          a phone by itself. */}
      <OneOf<Branch> name="first-week-branch" legend={BRANCH_QUESTION} value={value} onChange={setValue} options={BRANCH_OPTIONS} columns={3} />
      {failed && <p className="ds-fw__state">We could not save that just now. Try again in a minute.</p>}
      <Button variant="secondary" onClick={save} disabled={!value} loading={saving}>
        Continue
      </Button>
    </div>
  )
}
